import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=41b2b334"
import script from "./Unsubscribe.vue?vue&type=script&lang=ts"
export * from "./Unsubscribe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports